import React from 'react';
import PageTable from 'components/Shared/Page/Table';
import OffsetPaginationTable from 'components/Shared/OffsetPaginationTable';

const AuditLogsTable = ({
  columns,
  currentPage,
  dataSource,
  loading,
  totalCount,
  visible,
  onPageChange,
  onPageSizeChange,
  onTableChange,
}) => {
  return (
    <div data-testid="auditLogsTable">
      <PageTable
        visible={visible}
        table={
          <OffsetPaginationTable
            loading={loading}
            rowKey="id"
            columns={columns}
            current={currentPage}
            totalCount={totalCount}
            dataSource={dataSource}
            scroll={{
              x: true,
            }}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            onChange={onTableChange}
          />
        }
      />
    </div>
  );
};

export default AuditLogsTable;
